import type { ModalDeliverabilityIndexContactState } from 'Pages/RecipientsList/model'
import type { DeliverabilityList } from 'Types/beAccountDeliverabilityApi'
import { atom } from 'recoil'

export const deliverabilityIndexState = atom<DeliverabilityList>({
  key: 'recipientsList_deliverabilityIndexState',
  default: {
    ScoreData: { Score: 0 },
    AuditTip: '',
    AlertsData: {
      Audit: false,
    },
  },
})

export const modalDeliverabilityIndexContactState =
  atom<ModalDeliverabilityIndexContactState>({
    key: 'recipientsList_modalDeliverabilityIndexContactState',
    default: {
      show: false,
      email: '',
      text: '',
    },
  })
